import ArrowIcon from "@/components/icons/ArrowIcon";
import BurgerList from "@/components/icons/BurgerList";
import { modifyMegaMenuTreeData, sanitizeUrl } from "@/helpers/category";
import Link from "next/link";
import React, { useRef, useState } from "react";
import { useRouter } from "next/router";
import useOnClickOutside from "@/hooks/useOnClickOutside";
import CategoryList from "./CategoryList";
import { useClient } from "@/hooks/useClient";

const CategoriesDropdown = ({ menuTreeData }) => {
  const [open, setOpen] = useState(false);
  const { locale } = useRouter();
  const dropCatRef = useRef();
  const allCatRef = useRef();
  useOnClickOutside([dropCatRef, allCatRef], () => setOpen(false));
  const { isClient } = useClient();

  return (
    <div className="relative">
      {menuTreeData?.length > 0 && isClient && (
        <button
          ref={allCatRef}
          onClick={() => {
            setOpen((prev) => !prev);
          }}
          className="flex items-center justify-between w-40 py-4 cursor-pointer shrink-0"
        >
          <span className="flex items-center gap-4 ">
            <BurgerList />
            <span className="font-bold">
              {locale === "en" ? "All Categories" : "جميع الأقسام"}
            </span>
          </span>
          <ArrowIcon className="rotate-90 text-zinc-400 size-3" />
        </button>
      )}

      {open && (
        <ul
          ref={dropCatRef}
          className={`absolute ${
            locale === "ar" ? "right-0" : "left-0"
          } top-14 z-[100] flex w-64 flex-col gap-2 rounded-b-md  border bg-white p-2 shadow-categories`}
        >
          {menuTreeData?.map((cat, i) => {
            const parentUrl = `/cp/${cat?.url_key}`;
            const modifiedData = modifyMegaMenuTreeData(cat?.children_data);

            return (
              <li
                key={i}
                className="text-sm font-medium border border-transparent group hover:rounded-md hover:bg-tertiary-900 hover:text-white"
              >
                <Link
                  className="flex items-center justify-between px-4 py-2"
                  href={sanitizeUrl(parentUrl)}
                  onClick={() => setOpen(false)}
                >
                  <span>{cat?.name}</span>
                  {modifiedData?.length > 0 && (
                    <ArrowIcon
                      width={4}
                      height={8}
                      className={locale === "en" ? "" : "-rotate-180"}
                    />
                  )}
                </Link>

                {modifiedData?.length > 0 && (
                  <CategoryList
                    children_data={modifiedData}
                    banners={cat?.banners}
                    parentUrl={sanitizeUrl(parentUrl)}
                    sku_list={cat?.sku_list}
                    setOpen={setOpen}
                  />
                )}
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
};

export default CategoriesDropdown;
